import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouOpenType} from "../types/ForYouOpenType";
import {getOpenFromSimpleString} from "../utils/get_open_from_string";

type ForYouBannerGtmEventAction = "click" | "view";

export const ForYouBannerGtmEvent = (region: string, openFrom?: ForYouOpenType, action: ForYouBannerGtmEventAction = "click") => {
    const label = getOpenFromSimpleString(openFrom);
    const data = {
        event: ForYouEventType.BANNER,
        event_action: action,
        event_category: region,
        ...(label ? {custom_label: label} : {})
    };

    hitGoogleTagManager(data);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {ForYouEventType} from "../types/ForYouEventType";
import {ForYouOpenType} from "../types/ForYouOpenType";
import {getOpenFromSimpleString} from "../utils/get_open_from_string";

type ForYouBannerGtmEventAction = "click" | "view";

export const ForYouBannerGtmEvent = (region: string, openFrom?: ForYouOpenType, action: ForYouBannerGtmEventAction = "click") => {
    const label = getOpenFromSimpleString(openFrom);
    const data = {
        event: ForYouEventType.BANNER,
        event_action: action,
        event_category: region,
        ...(label ? {custom_label: label} : {})
    };

    hitGoogleTagManager(data);
};
